import Builder from '@/components/layout/Builder'
import HeroOnlyText from '@/components/sections/HeroOnlyText'
import { mapMoodArchiveStaticProps } from '@/utils/pageData'

import { WPPageData } from '@/types'

const MoodArchive = ({ pageData }: { pageData: WPPageData }) => (
  <>
    <HeroOnlyText {...pageData.acf.hero} />
    <Builder pageData={mapMoodArchiveStaticProps(pageData)} />
  </>
)

export default MoodArchive
